var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDankort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 548.2 359",
    enableBackground: "new 0 0 548.2 359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M368.5 37.8c-36.4 0-152.6 0-189 0-78.3 0-141.7 63.5-141.7 141.7 0 78.3 63.5 141.7 141.7 141.7 36.4 0 152.6 0 189 0 78.3 0 141.7-63.4 141.7-141.7 0-78.3-63.4-141.7-141.7-141.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E12726"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.5 170.9l62.8 74.7c13-18.8 20.7-41.6 20.7-66.2 0-25.9-8.5-49.9-22.9-69.3l-60.6 60.8zM223.5 103.9c46.9 0 82.3 11.9 85.9 51.5l49.4-51.5h98.3c-21.4-25-53.2-40.9-88.6-40.9h-189c-35.4 0-67.2 15.9-88.6 41 31.3-.1 104-.1 132.6-.1zM146.1 153.8l-16.8 46.1s49.6 0 67.6 0c20 0 26-8.3 30.5-24.2 4.4-15.8-6.7-21.9-20.4-21.9-11.3 0-60.9 0-60.9 0zM359.2 252L307 186c-9.7 45-41.3 66-100.5 66-44.5 0-96.5 0-118.1 0 21.4 26.8 54.3 44.1 91.2 44.1h189c36.9 0 69.8-17.2 91.2-44.1H359.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDankort);
export default __webpack_public_path__ + "static/media/dankort.ae547cd57e69a8d6976275a89d34da4a.svg";
export { ForwardRef as ReactComponent };